// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"179":"7073d18e","967":"d4d53c7a"}[chunkId] + ".js";
};